'use strict';

angular.module('pulianiBookStoreApp.util', []);
